import React,{useEffect,useState,useRef} from 'react'

import JoditEditor from 'jodit-react'
import { Link, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import articleService from '../../../services/articles.service'
import Loading from '../../common/Loading';
import { useNavigate } from 'react-router-dom';
export default function EditArticle() {
    const [content,setContent] = useState()
    const [category,setCategory] = useState([])
    const [article,setArticle] = useState()
    const {articleId} = useParams()
    const editor = useRef(null)
    const navigate = useNavigate()
    const config = {
        readonly:false,
        height:"80vh",
        disablePlugins: ['powered-by-jodit','file'],
          }
    const {
            register,
            handleSubmit,
            setValue,
            formState: { errors },
          } = useForm({
            defaultValues:article
          });

    useEffect(()=>{
        //get category list
        articleService.getArticlesCategory()
        .then(res=>{
            setCategory(res.data)
        })
        .catch(err=>{
            console.log(err)
        })
        
        articleService.getArticleById(articleId)
        .then(res=>{
            setArticle(res.data)
            setContent(res.data.content)
            setValue('id',res.data.id)
            setValue('title',res.data.title)
            setValue('summary',res.data.summary)
            setValue('status',res.data.status)
            setValue('articleCategoryId',res.data.articleCategoryId)
        
        })

    },[setValue])
    const onSubmit = (data)=>{
        const newData = {...data,content:content};
        articleService.saveArticles(newData)
        .then(res=>{
            toast.success("Article Saved",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
        })
        .catch(err=>{
            toast.error("Error while adding Article",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
            console.log(err)
        })
    }
    const handleDelete = ()=>{
        articleService.deleteArticles(articleId)
        .then(res=>{
            toast.success("Article Deleted",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
            navigate('/articles')
        })
        .catch(err=>{
            toast.error("Error while Deleting",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
        })
    }
   const handleCategory= ()=>{
        navigate('/articles/category')
   }
  return (
    <>
    <div className="pagetitle d-flex justify-content-between">
      <h1>Edit Article</h1>
      <div>
        

        <Link to="/articles" className="btn btn-sm btn-secondary">
          Cancel
        </Link>
      </div>
    </div>
  <div className="container mt-4">
      <div className="row">
          <div className="col-8"  style={{height:"100vh"}}>
          <JoditEditor 
              ref={editor} 
              value={content} 
              onChange={(newContent)=>{}}
              onBlur={newContent => setContent(newContent)}
              config={config}
              tabIndex = {1}
          />
          </div>
          <div className="col-4">
              <div className="card">
                  <div className="card-body">
                      <form onSubmit={handleSubmit(onSubmit)}>
                          <div className="d-flex justify-content-end mt-3">
                              <button type="submit" className="btn btn-success btn-sm"> <i className="bi bi-floppy-fill"></i> Save Article</button>
                          </div>
                          <div className="form-group mt-3">
                              <label htmlFor="" className="form-label">Title<span className="text-danger"><sup>*</sup></span></label>
                              <input type="text" {...register("title",{required:true})} className="form-control" />
                              {errors.title && <div className="text-danger">Title is required</div>}
                          </div>
                          <div className="form-group mt-3">
                              <label htmlFor="" className="form-label">Status</label>
                              <select {...register("status")} className="form-select">
                                  <option value="1">Active</option>
                                  <option value="0">Inactive</option>
                              </select>
                          </div>
                          <div className="form-group mt-3">
                            <div className="d-flex justify-content-between align-items-center">
                                <label htmlFor="" className="form-label">Category</label>
                                <button className="badge rounded-pill text-bg-info" type="button" onClick={handleCategory}>Manage</button>
                            </div>
                              
                              <select {...register("articleCategoryId")} className="form-select">
                                  {category && category.map((item,index)=>(
                                      <option key={index} value={item.id}>{item.title}</option>
                                  ))}
                              
                              </select>
                          </div>
                          <div className="form-group mt-3">
                              <label htmlFor="" className="form-label">Summary</label>
                              <textarea className="form-control" {...register("summary")} cols="30" rows="4"></textarea>
                          </div>
                      </form>

                      <div className="btn btn-lg btn-warning mt-3 mb-3" onClick={handleDelete}>Delete Article</div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  </>
  )
}
